import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../../core/modules/shared.module';
import { IndexCardConfigurationComponent } from './index-card-configuration.component';

@NgModule({
    declarations: [
        IndexCardConfigurationComponent
    ],
    imports: [
        SharedModule
    ],
    exports: [
        IndexCardConfigurationComponent
    ],
    entryComponents: [
        IndexCardConfigurationComponent
    ]
})
export class IndexCardConfigurationModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/configurations/index-card-configuration/index-card-configuration.module.ts